import script from "./ProvidersImportView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvidersImportView.vue?vue&type=script&setup=true&lang=js"

import "./ProvidersImportView.vue?vue&type=style&index=0&id=627ed77c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-627ed77c"]])

export default __exports__